import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const getCustomerContractType = async (params = {}) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/customer-contract-type',
    params: {
      limit: params?.limit,
      page: params?.page,
      sorts: params?.sorts?.length > 0 ? params.sorts : undefined,
      search: params?.search || undefined,
      customer_id: params?.customer_id
    },
  })

  return response?.data
}

export const show = async (type, customer_id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/customer-contract-type/${type}`,
    params: {
      customer_id: customer_id
    }
  })

  return response?.data
}